// Modules
import React, { useRef } from 'react'
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react'
import FeaturedImage from '../../../images/homepages/view-all-plans.webp'
import { navigate } from 'gatsby-link'
import { Link } from 'gatsby'

const Carousel = React.lazy(() =>
  import("./Carousel.js")
)

// Component: Featured section
function FeaturedSection ({ buttonID, buttonAction, buttonTitle, description, imageLink, plans, title, link="/personal/mobile/offers/bundles/" }) {
	// Data
	const isSSR = typeof window === "undefined"
	let width = 320
	let scrollPosition = 0
	let maxScrollWidth = 1920
	if ( typeof window !== 'undefined' && window.innerWidth <= 525) maxScrollWidth = 1920
	if ( typeof window !== 'undefined' && window.innerWidth <= 325) maxScrollWidth = 1200
	else maxScrollWidth = 1000
	// // else if (window.innerWidth >= 1501) maxScrollWidth = 1600


	const scrollReference = useRef()
	// Function
	function scroll (direction) {
		if (direction === 'left' && scrollPosition !== 0) scrollPosition += width
		if (direction === 'right' && Math.abs(scrollPosition) <= maxScrollWidth ) scrollPosition -= width
		scrollReference.current.style.marginLeft = `${scrollPosition}px`
	}

	// console.log(link)

	// Render
	return (
		<>
			{!isSSR && (
				<React.Suspense fallback={<div />}>
					<div className='relative'>
						<div className="container mx-auto hide-scrollbar">
							<div
								data-component="featured-section"
								className=" bg-surface_brand px-7 pb-5 lg:p-10  pt-0 rounded-lg">
								<div className="flex w-full items-center md:flex-row gap-10 md:gap-0 flex-col flex-wrap">
									<div className="lg:w-1/2 md:pt-16 pt-10 md:py-10">
										{!!title &&
											<p className="text-white font-black text-heading_lg md:text-display_sm">{title}</p>
										}
										{!!description &&
											<p className="text-white text-body_base mt-3">{description}</p>
										}
										{!!buttonTitle && !!buttonAction &&
											<button 
											id={buttonID}
											onClick={()=>navigate(`${buttonAction}`)}
												className="rounded-full bg-white hover:bg-negative text-body_sm font-bold md:body_base py-4 px-5 mt-4">
												{buttonTitle}
											</button>
										}
									</div>
									{/* {!!imageLink && */}
										<div className="hidden lg:block lg:w-1/2 max-h-100">
											<img
												className='w-full h-full max-h-100 object-contain' 
												src={FeaturedImage} />
										</div>
									{/* } */}
								</div>
								<div className="hidden lg:flex gap-4 mt-10 mb-5">
									<button
										className="flex justify-center items-center bg-telecel_white bg-opacity-10 text-telecel_white border-2 border-white rounded-full h-10 w-10 md:w-12 md:h-12"
										onClick={() =>  scroll('left')}>
										<ArrowLeft
											weight="bold"
											size={32} />
									</button>
									<button
										className="flex justify-center items-center bg-telecel_white bg-opacity-10 text-telecel_white border-2 border-white rounded-full h-10 w-10 md:w-12 md:h-12"
										onClick={() =>  scroll('right')}>
										<ArrowRight
											weight="bold"
											size={32} />
									</button>
								</div>
							
								<div 
									ref={scrollReference}
									className='hidden lg:block w-fit transition-all overflow-x-visible relative left-0 pb-6 md:pb-0' >
									<Carousel plans={plans} link={link} />
								</div>
							</div>
						</div>
						<div className='lg:hidden relative z-10 w-full flex overflow-x-scroll pb-10 hide-scroll-bar'>
									<div 
										className='flex overflow-x-scroll hide-scroll-bar gap-3 left-0 pb-6 md:pb-0' >
										{plans.length > 0 && plans.map((plan, index) =>
											<Link
												to={!!plan?.link ? plan.link : link}
												key={plan}
												className=" first:ml-12 last:mr-12 transition-all md:w-82 md:h-80 w-73 h-60 flex flex-shrink-0 bg-black text-white flex-col rounded-md p-8 pb-7">
												<p className="text-body_xl md:text-heading_2xl font-black">{plan.title}</p>
												{!!plan.description && <p className="mt-5 text-body_base line-clamp-3 md:line-clamp-4">{plan.description}</p>}
												{!!plan.price && <h3 className="self-end text-body_lg md:text-heading_lg font-black mt-auto">{`GHS ${plan.price}`}</h3>}
											</Link>
										)}
									</div>
						</div>
						<div className='lg:hidden absolute w-full md:h-90 h-72 bottom-8 md:bottom-2 z-1 px-5' >
							<div className='h-full bg-surface_brand rounded-b-lg' ></div>
						</div>
					</div>
				</React.Suspense>
			)}
		</>
	)
}

// Export
export default FeaturedSection
